export * from './FileFormatDocIcon';
export * from './FileFormatDocIcon16Light';
export * from './FileFormatDocIcon16Regular';
export * from './FileFormatDocIcon16Solid';
export * from './FileFormatDocIcon20Light';
export * from './FileFormatDocIcon20Regular';
export * from './FileFormatDocIcon20Solid';
export * from './FileFormatDocIcon24Regular';
export * from './FileFormatDocIcon24Solid';
export * from './FileFormatDocIcon32Regular';
export * from './FileFormatDocIcon64Regular';
